import { render, staticRenderFns } from "./tpinvoice.vue?vue&type=template&id=5fdf5c48&scoped=true"
import script from "./tpinvoice.vue?vue&type=script&lang=js"
export * from "./tpinvoice.vue?vue&type=script&lang=js"
import style0 from "./tpinvoice.vue?vue&type=style&index=0&id=5fdf5c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf5c48",
  null
  
)

export default component.exports